import AbstractDateTimePicker from "./abstract-date-time-picker";

export class DatePicker extends AbstractDateTimePicker {
    protected options(): {} {
        return $.extend(true, super.options(), {
            display: {
                viewMode: 'calendar',
                components: {
                    calendar: true,
                    clock: false,
                },
            },
        });
    }
}

// noinspection JSUnusedGlobalSymbols
export default () => {
    for (const $datePickerElement of $('.datepicker')) {
        new DatePicker($datePickerElement).createPicker();
    }
}